import { render, staticRenderFns } from "./MetadataForm.vue?vue&type=template&id=0fb1b5c3&scoped=true&"
import script from "./MetadataForm.vue?vue&type=script&lang=js&"
export * from "./MetadataForm.vue?vue&type=script&lang=js&"
import style0 from "./MetadataForm.vue?vue&type=style&index=0&id=0fb1b5c3&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb1b5c3",
  null
  
)

export default component.exports